import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOGesundheitsamtListStatus: 'idle',
    loadTOGesundheitsamtListError: undefined as any,
    loadTOGesundheitsamtListLastArgs: undefined as any,
    loadTOGesundheitsamtStatus: 'idle',
    loadTOGesundheitsamtError: undefined as any,
    saveTOGesundheitsamtStatus: 'idle',
    saveTOGesundheitsamtError: undefined as any,
    deleteTOGesundheitsamtStatus: 'idle',
    deleteTOGesundheitsamtError: undefined as any,

    toGesundheitsamtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOGesundheitsamtList = createAsyncThunk('toGesundheitsamtSlice/loadTOGesundheitsamtList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toGesundheitsamtSlice.loadTOGesundheitsamtListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/nuristogesheitamt/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOGesundheitsamtListStatus } = getState().toGesundheitsamtSlice
        return loadTOGesundheitsamtListStatus !== 'pending'
    }
})

export const loadTOGesundheitsamt = createAsyncThunk('toGesundheitsamtSlice/loadTOGesundheitsamt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristogesheitamt/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOGesundheitsamtStatus } = getState().toGesundheitsamtSlice
        return loadTOGesundheitsamtStatus !== 'pending'
    }
})

export const saveTOGesundheitsamt = createAsyncThunk('toGesundheitsamtSlice/saveTOGesundheitsamt', async ({ toGesundheitsamt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toGesundheitsamt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristogesheitamt/${ toGesundheitsamt?.HDR_ID }/`,
            prepareData(toGesundheitsamt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristogesheitamt/`,
            prepareData(toGesundheitsamt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOGesundheitsamtStatus } = getState().toGesundheitsamtSlice
        return saveTOGesundheitsamtStatus !== 'pending'
    }
})

export const deleteTOGesundheitsamt = createAsyncThunk('toGesundheitsamtSlice/deleteTOGesundheitsamt', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteTOGesundheitsamt/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOGesundheitsamtStatus } = getState().toGesundheitsamtSlice
        return deleteTOGesundheitsamtStatus !== 'pending'
    }
})

const ToGesundheitsamtSlice = createSlice({
    name: 'toGesundheitsamtSlice',
    initialState,
    reducers: {
        resetloadTOGesundheitsamtListError: (state) => {
            state.loadTOGesundheitsamtListError = undefined
        },
        resetloadTOGesundheitsamt: (state) => {
            state.formItem = undefined
            state.loadTOGesundheitsamtError = undefined
        },
        resetloadTOGesundheitsamtError: (state) => {
            state.loadTOGesundheitsamtError = undefined
        },
        resetsaveTOGesundheitsamt: (state) => {
            state.formItem = undefined
            state.saveTOGesundheitsamtError = undefined
        },
        resetsaveTOGesundheitsamtError: (state) => {
            state.saveTOGesundheitsamtError = undefined
        },
        resetdeleteTOGesundheitsamtError: (state) => {
            state.deleteTOGesundheitsamtError = undefined
        },
        removeFromToGesundheitsamtListById: (state, action) => {
            state.toGesundheitsamtList = state.toGesundheitsamtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToGesundheitsamtListByIds: (state, action) => {
            state.toGesundheitsamtList = state.toGesundheitsamtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toGesundheitsamtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOGesundheitsamtListStatus = 'preloaded'
            state.loadTOGesundheitsamtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toGesundheitsamtList = []
            state.loadTOGesundheitsamtListStatus = 'idle'
            state.loadTOGesundheitsamtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOGesundheitsamtList.pending, (state) => {
            state.loadTOGesundheitsamtListStatus = 'pending'
            state.loadTOGesundheitsamtListError = undefined
        })
        builder.addCase(loadTOGesundheitsamtList.fulfilled, (state, action) => {
            state.loadTOGesundheitsamtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOGesundheitsamtListLastArgs = action.payload.args

            {
                state.toGesundheitsamtList = action.payload.data

            }
        })
        builder.addCase(loadTOGesundheitsamtList.rejected, (state, action) => {
            state.loadTOGesundheitsamtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOGesundheitsamtListError = action.error.message
            } else {
                state.loadTOGesundheitsamtListError = action.payload
            }
        })

        builder.addCase(loadTOGesundheitsamt.pending, (state) => {
            state.loadTOGesundheitsamtStatus = 'pending'
            state.loadTOGesundheitsamtError = undefined
        })
        builder.addCase(loadTOGesundheitsamt.fulfilled, (state, action) => {
            state.loadTOGesundheitsamtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toGesundheitsamtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toGesundheitsamtList.push(newItem) }
                else { state.toGesundheitsamtList[i] = { ...state.toGesundheitsamtList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOGesundheitsamt.rejected, (state, action) => {
            state.loadTOGesundheitsamtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOGesundheitsamtError = action.error.message
            } else {
                state.loadTOGesundheitsamtError = action.payload
            }
        })

        builder.addCase(saveTOGesundheitsamt.pending, (state) => {
            state.saveTOGesundheitsamtStatus = 'pending'
            state.saveTOGesundheitsamtError = undefined
        })
        builder.addCase(saveTOGesundheitsamt.fulfilled, (state, action) => {
            state.saveTOGesundheitsamtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toGesundheitsamtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toGesundheitsamtList.push(newItem) }
                else { state.toGesundheitsamtList[i] = { ...state.toGesundheitsamtList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOGesundheitsamt.rejected, (state, action) => {
            state.saveTOGesundheitsamtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOGesundheitsamtError = action.error.message
            } else {
                state.saveTOGesundheitsamtError = action.payload
            }
        })

        builder.addCase(deleteTOGesundheitsamt.pending, (state) => {
            state.deleteTOGesundheitsamtStatus = 'pending'
            state.deleteTOGesundheitsamtError = undefined
        })
        builder.addCase(deleteTOGesundheitsamt.fulfilled, (state, action) => {
            state.deleteTOGesundheitsamtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.toGesundheitsamtList = state.toGesundheitsamtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.toGesundheitsamtList = state.toGesundheitsamtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOGesundheitsamt.rejected, (state, action) => {
            state.deleteTOGesundheitsamtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOGesundheitsamtError = action.error.message
            } else {
                state.deleteTOGesundheitsamtError = action.payload
            }
        })

    }
})

export const {
    resetloadTOGesundheitsamtListError,
    resetloadTOGesundheitsamt,
    resetloadTOGesundheitsamtError,
    resetsaveTOGesundheitsamt,
    resetsaveTOGesundheitsamtError,
    resetdeleteTOGesundheitsamtError,
    removeFromToGesundheitsamtListById,
    removeFromToGesundheitsamtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToGesundheitsamtSlice.actions
export default ToGesundheitsamtSlice.reducer
